
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useLocale from 'next-translate/useTranslation';
import React from 'react';
import CTAwithimagetiles from '@/components/CTAwithimagetiles';
import EarningsCalculator from '@/components/EarningsCalculator';
import FaqAffiliates from '@/components/FaqAffiliates';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import ButtonLink from '@/components/links/ButtonLink';
import LogosCloud from '@/components/LogosCloud';
import Seo from '@/components/Seo';
import TeamSection from '@/components/TeamSection';
import Testimonials from '@/components/Testimonials';
import TranscriptionFeaturesAffil from '@/components/TranscriptionFeaturesAffil';
const Templates = () => {
    const { t } = useLocale('affiliates');
    return (<main className='relative bg-gray-100 dark:bg-slate-900'>
      <Seo templateTitle={t('Affiliate Program | Earn 30% commission on all payments lifetime')} description={t('Join our affiliate program and start earning a constant commission of 30% on all payments you refer to Easy-Peasy.AI')} image={`https://easy-peasy.ai/api/og-template?title=${encodeURIComponent(t('Affiliate Program'))}`}/>
      <div className='relative bg-white dark:bg-slate-900'>
        <div className='mx-auto'>
          <LandingPageNavigation />
          <div className='relative z-10 bg-white pb-8 dark:bg-slate-900  lg:w-full'>
            <div className='relative  bg-white dark:bg-slate-900'>
              <div className='mx-auto max-w-7xl'>
                <main className='mx-auto mt-16 max-w-7xl px-4 sm:mt-24 sm:px-6 lg:mt-32'>
                  <div className='text-center'>
                    <h1>
                      <span className='mx-auto mt-2 block max-w-6xl text-4xl font-bold tracking-tight sm:text-5xl'>
                        <span className='text-white-600 block'>
                          {t('Receive a constant commission of')}
                        </span>
                        <span className='bg-gradient-to-r from-purple-400 to-pink-600 bg-clip-text text-6xl font-bold text-transparent'>
                          {t('30%')}
                        </span>
                        <span className='block text-primary-600'>
                          {t('on all payments you refer to Easy-Peasy.AI')}
                        </span>
                      </span>
                    </h1>
                    <p className='mx-auto mt-3 max-w-2xl text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl'>
                      {t('Sign up today and start sharing the power of Easy-Peasy.AI with your audience. They will thank you for it and you will enjoy the rewards of helping them reach their full potential.')}
                    </p>
                    <div className='mt-12'>
                      <ButtonLink href='https://easy-peasy-ai.getrewardful.com/signup' variant='dark'>
                        {t('Start to earn now')} 🚀
                      </ButtonLink>
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LogosCloud />
      <TranscriptionFeaturesAffil />
      <TeamSection />
      <EarningsCalculator />
      <FaqAffiliates />

      {/* <ContactUs /> */}
      <CTAwithimagetiles />
      {/* <CallToAction /> */}
      <Testimonials />
      <Footer />
    </main>);
};
export default Templates;
// add static props
async function getStaticProps() {
    return {
        props: {},
    };
}

    async function __Next_Translate__getStaticProps__1a1052e917a__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/affiliates',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1052e917a__ as getStaticProps }
  